import React, { Component } from 'react';
import { connect } from "react-redux";

import ApplicationMessages from '../inAppMessages/ApplicationMessages';
import HighlightOnInAppMessage from '../inAppMessages/HighlightOninAppMessage';

import AUTHENTICATION_API from '../../controllers/authentication';
import LANGUAGES_CONTROLLER from '../../controllers/languages'
import MANAGED_UX_FORMS_CONTROLLER from '../../controllers/managedUxForms';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import Logger, { LOG_LEVELS, ALL_MESSAGES } from '../../utils/logger';
import { withFullStoryExclude } from '../../utils/fullStoryHelper';

const FORM_NAME = 'LOGIN_FORM';
const log = new Logger(FORM_NAME, LOG_LEVELS.DEBUG);
const EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/; // From http://emailregex.com/

export class LoginForm extends Component {
  render() {
    const fieldValues = this.props.formData && this.props.formData.fieldValues;

    return (
      <main>
        <s-container class="max-width">
          <s-row>
            <s-col span="sm-10 md-8 lg-6 4" offset="sm-2 md-4 lg-6 8">
              <s-box class="pad-all-lg" name="login-panel" data-test="component-input-page">
                <form className="form" onSubmit={this.onSubmit.bind(this)}>
                  <fieldset>
                    <h2 className="alt">{LANGUAGES_CONTROLLER.format(this.props.languages, 'LogInTitle')}</h2>
                    <h3 className="alt">{LANGUAGES_CONTROLLER.format(this.props.languages, 'LogInHelpText')}</h3>
                    <ApplicationMessages scopes={[FORM_NAME]} messageType="applicationWarning" />
                    <ApplicationMessages scopes={[FORM_NAME]} messageType="applicationError" />
                    <HighlightOnInAppMessage
                      scopes={[FORM_NAME]}
                      messageIds={[ALL_MESSAGES.INVALID_USERNAME]}
                    >
                      <div className="form__field-wrapper input-container mb20">
                        <label className="form__field-label" htmlFor="username">{LANGUAGES_CONTROLLER.format(this.props.languages, 'UsernameLabel')}</label>
                        <input
                          className="form__field-input"
                          type="text"
                          value={(fieldValues && fieldValues.username) || ''}
                          placeholder={LANGUAGES_CONTROLLER.format(this.props.languages, 'UsernameLabel')}
                          onChange={this.onFieldChangeHandlerFactory('username').bind(this)}
                          autoCorrect="off"
                          autoCapitalize="off"
                          spellCheck="false"
                          data-test="input-username"
                        />
                      </div>
                    </HighlightOnInAppMessage>
                    <HighlightOnInAppMessage
                      scopes={[FORM_NAME]}
                      messageIds={[ALL_MESSAGES.BLANK_PASSWORD]}
                    >
                      <div className="form__field-wrapper input-container">
                        <label className="form__field-label" htmlFor="password">{LANGUAGES_CONTROLLER.format(this.props.languages, 'PasswordLabel')}</label>
                        <input
                          className={withFullStoryExclude("form__field-input mb5")}
                          type="password"
                          value={(fieldValues && fieldValues.password) || ''}
                          placeholder="••••••••••"
                          onChange={this.onFieldChangeHandlerFactory('password').bind(this)}
                          data-test="input-password"
                        />
                      </div>
                    </HighlightOnInAppMessage>

                    {/*<hr /> SVR-2221 commented out and added clear div below*/}
                    <div className="clear"></div>
                    <div className="form__submit-btn-wrapper">
                      <button className="primary large mb20" data-test="button-submit" type="submit">{LANGUAGES_CONTROLLER.format(this.props.languages, 'LogInButton')}</button>
                    </div>
                    <div>
                      <span>{LANGUAGES_CONTROLLER.format(this.props.languages, 'LogInSupport')} {LANGUAGES_CONTROLLER.format(this.props.languages, 'UK')} </span>
                      <a href="tel:01273022450"><LanguageStringResolver string="login_UKPhoneNumber" /></a>
                      <br />
                      <p><LanguageStringResolver string="login_forHelp" /> <a href="https://help.avalara.com/008_VAT_Learning_Center/Avalara_VAT_Reporting_(Cloud_version)"><LanguageStringResolver string="login_helpCenter" /></a></p>
                    </div>
                  </fieldset>
                </form>
              </s-box>
              <div className="clear"></div>
            </s-col>
          </s-row>
        </s-container>
      </main>
    );
  }
  UNSAFE_componentWillMount() {
    log.debug('componentWillMount(): ', this.props);
    log.clearDictionaryError(ALL_MESSAGES.INVALID_USERNAME);
    log.clearDictionaryError(ALL_MESSAGES.BLANK_PASSWORD);
    log.clearDictionaryError(ALL_MESSAGES.INVALID_LOGIN_CREDENTIALS);
    this.props.doInitialiseForm({ username: '', password: '', errorMessage: null });
    // this.props.doInitialiseForm(this.props.userLogin);

  }
  componentWillUnmount() {
    log.debug('componentWillUnmount(): ', this.props);
    this.props.doDestroyForm(FORM_NAME);
  }
  onFieldChangeHandlerFactory(fieldName) {
    return (evt) => {
      log.clearDictionaryError(ALL_MESSAGES.INVALID_USERNAME);
      log.clearDictionaryError(ALL_MESSAGES.BLANK_PASSWORD);
      log.clearDictionaryError(ALL_MESSAGES.INVALID_LOGIN_CREDENTIALS);
      this.props.onFieldChange(fieldName, evt.target.value)
    }
  }

  // onSubmit call the passed onSubmit function
  onSubmit(evt) {
    log.debug('onSubmit(): clearing errors', ALL_MESSAGES.INVALID_USERNAME, ALL_MESSAGES.BLANK_PASSWORD, ALL_MESSAGES.INVALID_LOGIN_CREDENTIALS);

    log.clearDictionaryError(ALL_MESSAGES.INVALID_USERNAME);
    log.clearDictionaryError(ALL_MESSAGES.BLANK_PASSWORD);
    log.clearDictionaryError(ALL_MESSAGES.INVALID_LOGIN_CREDENTIALS);
    log.clearDictionaryError(ALL_MESSAGES.CONNECTION_ERROR);
    let fieldsOk = true;
    evt.preventDefault();
    const username = this.props.formData.fieldValues.username.trim();
    const password = this.props.formData.fieldValues.password.trim();

    if (!EMAIL_REGEX.test(username)) {
      log.setDictionaryMessage(ALL_MESSAGES.INVALID_USERNAME);
      fieldsOk = false;
    }
    if (password === '') {
      log.setDictionaryMessage(ALL_MESSAGES.BLANK_PASSWORD);
      fieldsOk = false;
    }

    if (!fieldsOk) {
      return;
    }

    this.props.onAttemptLogin(username, password, (authInfo) => {
      log.debug('onSubmit().onAttemptLogin: success: ', authInfo);
      this.props.onSuccessHandler(authInfo)
    }, (error) => {
      if (error.status > 499)
        log.setDictionaryMessage(ALL_MESSAGES.CONNECTION_ERROR);
      else if (error.status === 401)
        log.setDictionaryMessage(ALL_MESSAGES.INVALID_LOGIN_CREDENTIALS);
      this.props.onFailHandler(error);
    });
  }
}




function mapStateToProps(state, props) {
  log.debug('mapStateToProps(): ', state);
  log.debug('mapStateToProps(): props', props);

  return {
    languages: state.languages,
    formData: (state.managedUxForms && state.managedUxForms.forms[FORM_NAME]),
  };
}

function mapDispatchersToProps(dispatch) {
  return {

    doInitialiseForm: (initialValues) => {
      dispatch(MANAGED_UX_FORMS_CONTROLLER.doInitialiseForm(FORM_NAME, initialValues));
    },
    doResetForm: () => {
      dispatch(MANAGED_UX_FORMS_CONTROLLER.doResetFormFieldsToInitialValues(FORM_NAME));
    },
    doClearForm: () => {
      dispatch(MANAGED_UX_FORMS_CONTROLLER.doClearFormFields(FORM_NAME));
    },
    onFieldChange: (fieldName, value) => {
      dispatch(MANAGED_UX_FORMS_CONTROLLER.doFormFieldChange(FORM_NAME, fieldName, value));
    },
    doFormSubmitted: (fieldName, value) => {
      dispatch(MANAGED_UX_FORMS_CONTROLLER.doFormSubmitted(FORM_NAME));
    },
    doDestroyForm: () => {
      dispatch(MANAGED_UX_FORMS_CONTROLLER.doRemoveForm(FORM_NAME));
    },

    onAttemptLogin: (username, password, successHandler, failureHandler) => {
      log.debug('onAttemptLogin:');
      dispatch(AUTHENTICATION_API.doAttemptLogin(username, password, (authInfo) => {
        successHandler(authInfo);
      }, (error) => {
        failureHandler(error);
      }));
    },
  };
}
export default connect(mapStateToProps, mapDispatchersToProps)(LoginForm);
